import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

function EducationFormDialog({ open, onClose, onSave, cvId, education }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: education || {
            level: '',
            field: '',
            location: '',
            start_date: '',
            end_date: ''
        }
    });

    const toDateInput = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toISOString().split('T')[0];
    };

    React.useEffect(() => {
        if (education) {
            reset({
                ...education,
                start_date: toDateInput(education.start_date),
                end_date: toDateInput(education.end_date),
            });
        } else {
            reset({
                level: '',
                field: '',
                location: '',
                start_date: '',
                end_date: ''
            });
        }
    }, [education, reset]);

    const formatDateForAPI = (dateStr) => {
        if (!dateStr) return null;
        return `${dateStr}T00:00:00Z`;
    };

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                start_date: formatDateForAPI(data.start_date),
                end_date: formatDateForAPI(data.end_date),
                id: education?.id || null,
                cv: cvId,
                user: null
            };
            await CVHttpService.saveEducation(body);
            onSave();
        } catch (err) {
            alert('Failed to save education');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{education ? 'Edit Education' : 'Add Education'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Level *"
                            {...register('level', { required: 'Education level is required' })}
                            error={!!errors.level}
                            helperText={errors.level?.message || 'e.g., Bachelor, Master, PhD'}
                        />
                        <TextField
                            fullWidth
                            label="Field"
                            {...register('field')}
                            helperText="e.g., Computer Science, Business Administration"
                        />
                        <TextField
                            fullWidth
                            label="Location"
                            {...register('location')}
                            helperText="e.g., University name, city"
                        />
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="Start Date"
                                    type="date"
                                    {...register('start_date')}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="End Date"
                                    type="date"
                                    {...register('end_date')}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default EducationFormDialog;

